<template>
  <div id="faq-section" class="d-flex-row gap-0" v-once>

    <div
      class="main_box flex-10 d-flex-column justify-start pad-2 pad-b-0 gap-0"
    >
      <div
        class="d-flex-row align-start justify-start gap-0 flex-1"
        style="margin-bottom: 50px"
      >
        <div class="d-flex-column gap-0">
          <p
            class="t-orange regular-l f-w-500 font-family-1"
            style="letter-spacing: 2px"
          >
            {{ $t("homepage.faq") }}
          </p>
          <h2
            class="t-white font-family-1 title-h2 f-w-600"
            style="text-align: center"
          >
            {{ $t("homepage.got_a_question") }}
            <br />
            {{ $t("homepage.we_have")
            }}<span class="t-light-orange">{{ $t("homepage.answers") }}</span
            >!
          </h2>
        </div>
      </div>

      <!-- <faq :faqs="faqs" /> -->
      <div class="d-flex-row align-start lg-row-to-col">
        <div class="d-flex-column gap-0">
          <Faq :faqs="[...faqs].splice(0, 5)" variant="pack twocol" />
        </div>
        <div class="d-flex-column gap-0">
          <Faq :faqs="[...faqs].splice(5, 6)" variant="pack twocol" />
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import Faq from "../custom/Faq.vue";
import { computed } from "vue";
const { t } = useI18n();

const faqs = computed(() => {
  return [
    {
      question: t("work_with_us_2.faqs.question_1"),
      answer: t("work_with_us_2.faqs.answer_1"),
    },
    {
      question: t("work_with_us_2.faqs.question_2"),
      answer: t("work_with_us_2.faqs.answer_2"),
    },
    {
      question: t("work_with_us_2.faqs.question_3"),
      answer: t("work_with_us_2.faqs.answer_3"),
    },
    {
      question: t("work_with_us_2.faqs.question_4"),
      answer: t("work_with_us_2.faqs.answer_4"),
    },
    {
      question: t("work_with_us_2.faqs.question_5"),
      answer: t("work_with_us_2.faqs.answer_5"),
    },
    {
      question: t("work_with_us_2.faqs.question_6"),
      answer: t("work_with_us_2.faqs.answer_6"),
    },
    {
      question: t("work_with_us_2.faqs.question_7"),
      answer: t("work_with_us_2.faqs.answer_7"),
    },
    {
      question: t("work_with_us_2.faqs.question_8"),
      answer: t("work_with_us_2.faqs.answer_8"),
    },
    {
      question: t("work_with_us_2.faqs.question_9"),
      answer: t("work_with_us_2.faqs.answer_9"),
    },
    {
      question: t("work_with_us_2.faqs.question_10"),
      answer: t("work_with_us_2.faqs.answer_10"),
    },
  ];
});
</script>
